import Link from 'components/link'
//@ts-ignore
import { storeSearchResultsPath } from 'lib/urls'
//@ts-ignore
import { bowserFlags } from 'lib/bowser'
//@ts-ignore
import { SectionHeading } from 'components/headings'
//@ts-ignore
import DeferredPaymentMessage from 'components/deferred-payment-message'
import MerchandisingMessage from 'components/merchandising-message'
import PriceDisplay from '../../price-display'
import { ReviewTeaser } from '../../product-reviews'
import InStockAlertLink from '../../in-stock-alert-link'
import css from './styles.scss'

interface ProductInfoProps {
  brand: string
  brandPageUrl?: string
  isElectronicGiftCard: boolean
  merchandisingMessage?: string
  name: string
  price: {
    current: number
    msrp: number
  }
  productId: number
  productType: string
  extendedDeliveryTimeMessage: string | null
  reviewSku: string
  showDeferredPaymentMessage: boolean
  showInStockNotificationLink: boolean
  showPrice: boolean
  surchargeModalPrompt: string | null
  reactRouterEnabled?: boolean | true
  titleDecorator?(component: any): any
}

const ProductInfo = ({
  brand,
  brandPageUrl,
  isElectronicGiftCard,
  merchandisingMessage,
  name,
  price,
  productId,
  productType,
  extendedDeliveryTimeMessage,
  surchargeModalPrompt,
  reactRouterEnabled = true,
  reviewSku,
  showDeferredPaymentMessage,
  showInStockNotificationLink,
  showPrice,
  titleDecorator,
}: ProductInfoProps) => (
  <div>
    <SectionHeading className={css.productName}>
      <span className="h7 text-uppercase mtl mtn-sm mbs block">
        <Link
          className="link-body-text"
          to={
            reactRouterEnabled
              ? brandPageUrl || storeSearchResultsPath(brand)
              : undefined
          }
          url={!reactRouterEnabled && storeSearchResultsPath(brand)}
          newWindow={!reactRouterEnabled}
        >
          {brand}{' '}
        </Link>
      </span>
      <span>{titleDecorator ? titleDecorator(name) : name}</span>
    </SectionHeading>
    {/* @ts-ignore */}
    <ReviewTeaser sku={reviewSku} />
    {showPrice && (price || isElectronicGiftCard) ? (
      <p className="mvs">
        <PriceDisplay
          price={price}
          priceClassName="h4"
          isElectronicGiftCard={isElectronicGiftCard}
        />
      </p>
    ) : null}
    {showDeferredPaymentMessage && (
      <DeferredPaymentMessage
        price={price.current}
        bgColor={bowserFlags.mobile ? 'white' : 'gray'}
        isElectronicGiftCard={isElectronicGiftCard}
      />
    )}
    <MerchandisingMessage
      merchandisingMessage={merchandisingMessage}
      surchargeModalPrompt={surchargeModalPrompt}
    />
    {showInStockNotificationLink && <InStockAlertLink productId={productId} />}
    {!showInStockNotificationLink && extendedDeliveryTimeMessage && (
      <p className="small mtm">{extendedDeliveryTimeMessage}</p>
    )}
    {productType === 'virtual_bundle' && (
      <div className="h7 mvs">Items may ship separately.</div>
    )}
  </div>
)

export default ProductInfo
